export default function ActivenessGroup() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="114.083"
      height="62.589"
      viewBox="0 0 114.083 62.589"
    >
      <g
        id="Group_33151"
        data-name="Group 33151"
        transform="translate(-816 -327.114)"
      >
        <path
          id="Path_36795"
          data-name="Path 36795"
          d="M29.733,262c14.737,0,26.683.872,26.683,1.946s-11.946,1.944-26.683,1.944S3.05,265.013,3.05,263.948,14.994,262,29.733,262Z"
          transform="translate(812.95 123.813)"
          fill="#bec5ed"
          fillRule="evenodd"
        />
        <path
          id="Path_36796"
          data-name="Path 36796"
          d="M29.733,262c14.737,0,26.683.872,26.683,1.946s-11.946,1.944-26.683,1.944S3.05,265.013,3.05,263.948,14.994,262,29.733,262Z"
          transform="translate(873.667 123.813)"
          fill="#bec5ed"
          fillRule="evenodd"
        />
        <g id="Group_33150" data-name="Group 33150">
          <g id="character13" transform="translate(838.576 327.114)">
            <path
              id="Path_35681"
              data-name="Path 35681"
              d="M192.441,253.45c.494,4.782,4.838,17.019,5.583,18.34.174.3-1.076.728-1.221.471-.644-1.118-6.016-6.79-6.747-9.1a9.858,9.858,0,0,1-.108-4.7c.187-.872-.813-3.05-.609-3.646C189.554,254.151,192.4,253.026,192.441,253.45Z"
              transform="translate(-172.704 -216.9)"
              fill="#f7b690"
            />
            <path
              id="Path_35682"
              data-name="Path 35682"
              d="M230.668,365.2a.713.713,0,0,0-.349.986,19.4,19.4,0,0,1,1.427,3.1c.047.155.216,0,.523-.089.174-.051-1.108-2.322-.888-2.385.337-.1,1.628,2.1,1.72,2.081a18.964,18.964,0,0,0,2.627-.886c.324-.192-.55-.658-1.071-.7a4.949,4.949,0,0,0-1.467.295Z"
              transform="translate(-206.502 -309.23)"
              fill="#222b54"
            />
            <path
              id="Path_35683"
              data-name="Path 35683"
              d="M232.044,355.962a20.153,20.153,0,0,0,2.992,3.69,2.209,2.209,0,0,0-1.272.546c-.794-.389-2.036-2.1-2.655-2.39-.077-.035-.087-.066-.07-.15a1.6,1.6,0,0,0-.262-1.151C230.6,356.187,231.893,355.627,232.044,355.962Z"
              transform="translate(-206.922 -301.518)"
              fill="#f7b690"
            />
            <path
              id="Path_35684"
              data-name="Path 35684"
              d="M117.621,269.119c-.858,2.4-8.913,12.213-10.573,15.876-.155.349-1.479.251-1.434-.033s1.821-8.9,2.558-10.327c.961-1.858,4.166-3.505,4.166-3.505S118.094,267.8,117.621,269.119Z"
              transform="translate(-103.608 -229.655)"
              fill="#f7b690"
            />
            <path
              id="Path_35685"
              data-name="Path 35685"
              d="M100.08,363.407c-.471-.077-.728.349-.782.7a19.442,19.442,0,0,1-.213,3.409c-.031.159.19.1.5.174.174.035.124-2.57.349-2.521.349.073.438,2.617.523,2.648a18.849,18.849,0,0,0,2.732.462c.377-.016-.227-.923-.726-1.077s-1.31-.473-1.31-.473Z"
              transform="translate(-98.217 -307.742)"
              fill="#222b54"
            />
            <path
              id="Path_35686"
              data-name="Path 35686"
              d="M105.661,357.281a8.359,8.359,0,0,0,.649,4.379c.185.2-1.1-.038-1.256-.262-.523-.719-.776-2.662-1.185-3.208a.113.113,0,0,1,0-.166,2.786,2.786,0,0,0,.4-1.165C104.348,356.5,105.8,356.947,105.661,357.281Z"
              transform="translate(-102.139 -302.233)"
              fill="#f7b690"
            />
            <path
              id="Path_35687"
              data-name="Path 35687"
              d="M142.727,44.39c-2.268,0-3.344,1.97-4.885,2.837a11.652,11.652,0,0,1-5.792,1.5c.208.476.427.926.663,1.35a16.05,16.05,0,0,0,4.625-.7,10.374,10.374,0,0,1-4.206,1.4,10.409,10.409,0,0,0,1.851,2.184,11.021,11.021,0,0,0,2.443-.325,4.876,4.876,0,0,1-1.745.892,11.2,11.2,0,0,0,1.745,1.047c6.876,0,8.592-4.187,8.592-6.269C146.016,47,145.433,44.39,142.727,44.39Z"
              transform="translate(-125.433 -44.39)"
              fill="#cc346f"
            />
            <path
              id="Path_35688"
              data-name="Path 35688"
              d="M149.033,161.384c-.1.281-2.992,3-3.746,6.141-.595,2.467,1.984,10.285.077,14.693-.48,1.11,10.576.471,11.5-.523-.038-6.455.382-16.347-2.716-19.531-.23-.236-1.909.7-3.955.419C148.709,162.377,149.114,161.165,149.033,161.384Z"
              transform="translate(-136.286 -140.951)"
              fill="#0a3c5f"
            />
            <path
              id="Path_35689"
              data-name="Path 35689"
              d="M194.053,98.773c.3.511.408,1.964,1.237,4.3.216.609-2.308,1.5-2.458,1.092-.8-2.156-1.2-3.632-1.2-3.632S193.643,98.086,194.053,98.773Z"
              transform="translate(-174.618 -89.184)"
              fill="#a2d1eb"
            />
            <path
              id="Path_35690"
              data-name="Path 35690"
              d="M201.411,124.731c.649,1.626,1.624,4.362,1.959,4.459.523.14,4.479,4.271,4.479,4.271s-.15,1.172-.677.947a33.021,33.021,0,0,1-5.026-3.064c-.766-.539-2.46-3.46-2.982-5.618C199.1,125.47,201.259,124.35,201.411,124.731Z"
              transform="translate(-180.837 -110.65)"
              fill="#f7b690"
            />
            <path
              id="Path_35691"
              data-name="Path 35691"
              d="M167.133,90.32a12.46,12.46,0,0,0-3.461,1.453c-1.5,1.015-.157,6.38-.3,8.329a33.428,33.428,0,0,1-.476,3.332c-.112.7,5.428,1.146,6.05.577.461-.419.058-5.5.6-5.839a2.2,2.2,0,0,0,1.073-1.293c.112-.379-.438-1.951-.492-2.95a7.246,7.246,0,0,1,.234-1.959C170.246,91.466,167.946,90.32,167.133,90.32Z"
              transform="translate(-150.893 -82.307)"
              fill="#a2d1eb"
            />
            <path
              id="Path_35692"
              data-name="Path 35692"
              d="M179.157,91.594a2,2,0,0,0,1.952,1.607.636.636,0,0,0,.6-.8s.621.466.937.225.059-.7-.632-1.254C181.17,90.69,179.012,90.778,179.157,91.594Z"
              transform="translate(-164.316 -82.798)"
              fill="#f7f6f1"
            />
            <path
              id="Path_35693"
              data-name="Path 35693"
              d="M183.545,72.227a8.815,8.815,0,0,1-.087-2.186,15.2,15.2,0,0,1-1.619-2.381,13.2,13.2,0,0,1-.482,4.2C180.755,72.543,183.807,72.92,183.545,72.227Z"
              transform="translate(-166.072 -63.6)"
              fill="#f7b690"
            />
            <path
              id="Path_35694"
              data-name="Path 35694"
              d="M184.165,57.753c-.07-.3-.174-.731-.469-.612-.174.072-.316,1.317.082,1.363-.028.33.656,2.741,2.476,2.73.4,0,1.465-1.4,1.465-4.372C187.719,55.319,185.191,56.827,184.165,57.753Z"
              transform="translate(-167.925 -54.138)"
              fill="#f7b690"
            />
            <path
              id="Path_35695"
              data-name="Path 35695"
              d="M154.687,97.29c-1.57.574-3.3,2.915-3.252,3.538s1.745,2.167,2.094,2.207c.427.049,2.748-2.716,2.748-2.716S155.454,97.009,154.687,97.29Z"
              transform="translate(-141.434 -88.047)"
              fill="#a2d1eb"
            />
            <path
              id="Path_35696"
              data-name="Path 35696"
              d="M121.457,119.608c-.393.4-3.015,3.69-3.332,4.266-.349.647-4.287,6.825-4.711,7.471-.209.318-.96-.393-.769-.851,1.022-2.443,2.167-6.056,3.358-8.025a37.814,37.814,0,0,1,3.4-4.711C119.981,117.08,121.894,119.172,121.457,119.608Z"
              transform="translate(-109.388 -104.847)"
              fill="#f7b690"
            />
            <path
              id="Path_35697"
              data-name="Path 35697"
              d="M98.207,192.247c-.241.307-.148.633-.106,1.026.061.571-.22.919-.249,1.263-.021.229.1.349.085.523s-.291.113-.546-.359c-.08-.15.073-.509.092-.668.016-.117-.192-.092-.312-.035-.68.579-1.357,2.219-1.57,1.958-.154-.19.661-1.57.583-1.635s-1.382,1.551-1.589,1.366,1.321-1.652,1.275-1.724-1.4,1.27-1.57,1.047,1.221-1.343,1.206-1.4c-.031-.1-1.263.755-1.37.6-.174-.263,1.37-.961,1.45-1.12a12.158,12.158,0,0,0,1.783-1.591C97.377,191.487,98.443,191.945,98.207,192.247Z"
              transform="translate(-94.121 -165.833)"
              fill="#f7b690"
            />
            <path
              id="Path_35698"
              data-name="Path 35698"
              d="M199.64,115.544h-.012a.094.094,0,0,1-.077-.112.987.987,0,0,1,.188-.422,1.085,1.085,0,0,1,.2-.148,1.745,1.745,0,0,0,.85-1.1,3.394,3.394,0,0,0-.192-1.438,3.614,3.614,0,0,1-.2-1.446.1.1,0,1,1,.188.038,3.457,3.457,0,0,0,.2,1.359,3.5,3.5,0,0,1,.194,1.532,1.919,1.919,0,0,1-.932,1.221,1.065,1.065,0,0,0-.164.119.769.769,0,0,0-.141.326A.1.1,0,0,1,199.64,115.544Z"
              transform="translate(-181.156 -99.213)"
              fill="#2a95bf"
            />
            <path
              id="Path_35699"
              data-name="Path 35699"
              d="M170.818,227.342a.094.094,0,0,1-.058-.021.091.091,0,0,1-.012-.129,9.253,9.253,0,0,0,1.415-2.366c.717-2.111.958-5.128,1.221-9.159a.094.094,0,0,1,.1-.087.092.092,0,0,1,.085.1c-.263,4.046-.508,7.075-1.232,9.208a9.343,9.343,0,0,1-1.448,2.422A.087.087,0,0,1,170.818,227.342Z"
              transform="translate(-157.362 -185.713)"
              fill="#265b80"
            />
            <path
              id="Path_35700"
              data-name="Path 35700"
              d="M245.8,174.736c.222.155.537.023.885-.056.508-.115.895.145,1.207.136.206,0,.305-.131.454-.133s.126.349-.272.63c-.126.087-.37-.026-.513-.028-.106,0-.154.1-.089.2.591.55,1.335.523,1.193.8-.1.2-.349.215-.577.188a1.779,1.779,0,0,1-1.453.448c-.991-.454-1.047-.939-1.511-1.239C245.111,175.684,245.5,174.537,245.8,174.736Z"
              transform="translate(-218.775 -151.925)"
              fill="#f7b690"
            />
            <path
              id="Path_35701"
              data-name="Path 35701"
              d="M254.537,177.171l-6.733,6.551a.724.724,0,0,1-1.047-.1l-4.2-4.894a.349.349,0,0,1,0-.475l6.649-6.469a.349.349,0,0,1,.476.012l4.784,4.335a.722.722,0,0,1,.068,1.04Z"
              transform="translate(-216.585 -149.485)"
              fill="#945e40"
            />
            <path
              id="Path_35702"
              data-name="Path 35702"
              d="M296.893,185.61a.134.134,0,0,1-.085-.033l-.131-.119a.127.127,0,0,1,0-.174.126.126,0,0,1,.174,0l.133.119a.129.129,0,0,1,.009.174.127.127,0,0,1-.1.033Z"
              transform="translate(-261.309 -160.673)"
              fill="#69402a"
            />
            <path
              id="Path_35703"
              data-name="Path 35703"
              d="M260.069,196.719a.47.47,0,0,1-.085,0,.126.126,0,1,1,.037-.249.307.307,0,0,0,.237-.063.127.127,0,0,1,.161.2.541.541,0,0,1-.349.115Zm-.377-.174a.131.131,0,0,1-.094-.042v-.012l-.225-.262a.13.13,0,1,1,.192-.174l.23.27a.126.126,0,0,1-.009.174.122.122,0,0,1-.094.047Zm.9-.174a.129.129,0,0,1-.091-.038.127.127,0,0,1,0-.174l.257-.249a.126.126,0,1,1,.174.174l-.256.249a.122.122,0,0,1-.084.045Zm-1.37-.375a.124.124,0,0,1-.1-.044l-.234-.272a.127.127,0,1,1,.194-.166l.232.272a.126.126,0,0,1-.1.209Zm1.882-.126a.122.122,0,0,1-.091-.038.126.126,0,0,1,0-.174l.258-.251a.126.126,0,0,1,.174,0,.127.127,0,0,1,0,.174l-.256.249a.133.133,0,0,1-.086.047Zm-2.348-.412a.124.124,0,0,1-.1-.044l-.234-.272a.127.127,0,0,1,.014-.174.126.126,0,0,1,.174.014l.234.272a.126.126,0,0,1-.014.174A.119.119,0,0,1,258.761,195.457Zm2.861-.08a.126.126,0,0,1-.091-.038.127.127,0,0,1,0-.174l.256-.249a.127.127,0,0,1,.174,0,.126.126,0,0,1,0,.174l-.256.249a.124.124,0,0,1-.084.038Zm-3.325-.462a.124.124,0,0,1-.1-.045l-.234-.272a.126.126,0,0,1,.192-.164l.234.272a.127.127,0,0,1-.1.209Zm3.838-.037a.129.129,0,0,1-.091-.038.127.127,0,0,1,0-.174l.265-.255a.127.127,0,0,1,.174,0,.129.129,0,0,1,0,.174l-.258.249A.122.122,0,0,1,262.135,194.878Zm.513-.5a.122.122,0,0,1-.091-.038.126.126,0,0,1,0-.174l.258-.251a.126.126,0,0,1,.174,0,.127.127,0,0,1,0,.174l-.256.249a.133.133,0,0,1-.075.04Zm.513-.5a.126.126,0,0,1-.091-.038.127.127,0,0,1,0-.174l.256-.249a.127.127,0,0,1,.174,0,.126.126,0,0,1,0,.174l-.256.249a.124.124,0,0,1-.082.047Zm.515-.5a.129.129,0,0,1-.091-.038.127.127,0,0,1,0-.174l.256-.249a.127.127,0,0,1,.174,0,.129.129,0,0,1,0,.174l-.258.249a.122.122,0,0,1-.08.038Zm.513-.5a.122.122,0,0,1-.091-.038.126.126,0,0,1,0-.174l.258-.251a.126.126,0,0,1,.174,0,.127.127,0,0,1,0,.174l-.251.251a.133.133,0,0,1-.089.038Zm.513-.5a.129.129,0,0,1-.091-.038.127.127,0,0,1,0-.174l.256-.249a.127.127,0,0,1,.174,0,.126.126,0,0,1,0,.174l-.257.249a.124.124,0,0,1-.082.038Zm.515-.5a.129.129,0,0,1-.091-.038.127.127,0,0,1,0-.174l.256-.249a.127.127,0,0,1,.174,0,.129.129,0,0,1,0,.174l-.258.249a.122.122,0,0,1-.08.038Zm.513-.5a.122.122,0,0,1-.091-.038.126.126,0,0,1,0-.174l.258-.249a.124.124,0,0,1,.174,0,.127.127,0,0,1,0,.174l-.257.249a.133.133,0,0,1-.084.038Zm.513-.5a.129.129,0,0,1-.091-.038.127.127,0,0,1,0-.174l.256-.249a.127.127,0,0,1,.174,0,.126.126,0,0,1,0,.174l-.256.249a.124.124,0,0,1-.082.038Zm.515-.5a.129.129,0,0,1-.091-.038.127.127,0,0,1,0-.174l.256-.249a.127.127,0,0,1,.174,0,.129.129,0,0,1,0,.174l-.251.251a.122.122,0,0,1-.087.037Zm.5-.515a.106.106,0,0,1-.056-.014.124.124,0,0,1-.056-.174.314.314,0,0,0,.031-.14.357.357,0,0,0-.019-.112.129.129,0,0,1,.082-.161.124.124,0,0,1,.159.08.606.606,0,0,1,.031.192.569.569,0,0,1-.059.253.124.124,0,0,1-.112.082Zm-.19-.63a.134.134,0,0,1-.086-.033l-.265-.241a.128.128,0,1,1,.174-.188l.265.241a.127.127,0,0,1,.009.174.124.124,0,0,1-.1.047Zm-.523-.482a.122.122,0,0,1-.085-.033l-.27-.244a.128.128,0,0,1,.174-.187l.267.239a.129.129,0,0,1,.009.174.127.127,0,0,1-.1.051Zm-.523-.482a.122.122,0,0,1-.085-.033l-.265-.241a.128.128,0,0,1,.174-.187l.265.241a.126.126,0,0,1,.009.174.124.124,0,0,1-.11.045Zm-.532-.482a.126.126,0,0,1-.084-.031l-.267-.241a.129.129,0,0,1-.009-.174.127.127,0,0,1,.174,0l.265.241a.127.127,0,0,1,.009.174.129.129,0,0,1-.1.031Z"
              transform="translate(-229.357 -162.377)"
              fill="#69402a"
            />
            <path
              id="Path_35704"
              data-name="Path 35704"
              d="M256.171,225.954a.127.127,0,0,1-.1-.044l-.115-.136a.126.126,0,0,1,.012-.174.129.129,0,0,1,.174.014l.115.134a.127.127,0,0,1-.014.174A.124.124,0,0,1,256.171,225.954Z"
              transform="translate(-227.701 -193.962)"
              fill="#69402a"
            />
            <path
              id="Path_35705"
              data-name="Path 35705"
              d="M250.4,182l-.044-.047c-.012-.016-.03-.035-.049-.056a.631.631,0,0,1-.068-.084,2.349,2.349,0,0,1-.174-.26l-.044-.08c-.016-.028-.028-.059-.042-.089a1.742,1.742,0,0,1-.077-.2c-.01-.035-.023-.072-.033-.108s-.019-.077-.028-.117a1.85,1.85,0,0,1-.037-.251,1.994,1.994,0,0,1,.026-.553l.014-.073.019-.072a1.489,1.489,0,0,1,.044-.143l.052-.143.068-.138a2.023,2.023,0,0,1,.373-.5,1.951,1.951,0,0,1,.513-.365,1.984,1.984,0,0,1,1.134-.174.642.642,0,0,1,.127.019l.12.028a1.972,1.972,0,0,1,.223.068,2.094,2.094,0,0,1,.359.174l.073.042c.023.014.044.03.065.045l.112.08c.065.051.112.1.145.126l.049.045a.178.178,0,0,1-.187.3h-.016l-.056-.023-.154-.065-.11-.038-.063-.023-.066-.019a2.62,2.62,0,0,0-.309-.07c-.056,0-.113-.021-.174-.021h-.183a1.76,1.76,0,0,0-.188.012.6.6,0,0,0-.094.017h-.049l-.047.014-.094.026-.092.033a1.729,1.729,0,0,0-.174.087,1.5,1.5,0,0,0-.324.242,1.7,1.7,0,0,0-.248.321,1.658,1.658,0,0,0-.157.368,1.828,1.828,0,0,0-.065.38,1.584,1.584,0,0,0,0,.174v.089l.01.086a1.5,1.5,0,0,0,.024.162.141.141,0,0,0,.014.075.229.229,0,0,1,.019.072c.023.094.051.174.07.234v.024l.01.023.019.045.028.072.023.059a.177.177,0,0,1-.3.185Z"
              transform="translate(-222.641 -155.122)"
              fill="#945e40"
            />
            <path
              id="Path_35706"
              data-name="Path 35706"
              d="M252.86,196.117l-.033-.045c-.021-.028-.047-.065-.072-.1-.049-.077-.092-.157-.092-.157a.078.078,0,1,1,.136-.075s.037.085.077.162c.019.038.04.077.056.1l.028.047a.06.06,0,0,1-.1.066Z"
              transform="translate(-224.995 -169.298)"
              fill="#69402a"
            />
            <path
              id="Path_35707"
              data-name="Path 35707"
              d="M251.38,192.159l-.019-.056c-.01-.031-.024-.077-.035-.122-.024-.089-.04-.174-.04-.174a.1.1,0,1,1,.206-.035,1.63,1.63,0,0,0,.026.174.476.476,0,0,0,.024.113l.014.052a.092.092,0,0,1-.174.056Z"
              transform="translate(-223.864 -165.981)"
              fill="#69402a"
            />
            <path
              id="Path_35708"
              data-name="Path 35708"
              d="M251.14,188.031v-.058a.5.5,0,0,1,.012-.129c.01-.094.031-.187.031-.187a.119.119,0,0,1,.232.051s-.021.084-.033.174a1.045,1.045,0,0,0-.014.113v.052a.113.113,0,0,1-.225-.01Z"
              transform="translate(-223.746 -162.585)"
              fill="#69402a"
            />
            <path
              id="Path_35709"
              data-name="Path 35709"
              d="M252,184.154l.024-.054c.016-.031.037-.073.061-.115.047-.082.1-.159.1-.159a.126.126,0,1,1,.2.145,1.378,1.378,0,0,0-.091.14c-.021.035-.04.072-.054.1l-.023.047a.124.124,0,0,1-.174.061A.122.122,0,0,1,252,184.154Z"
              transform="translate(-224.448 -159.448)"
              fill="#69402a"
            />
            <path
              id="Path_35710"
              data-name="Path 35710"
              d="M254.418,181.325l.044-.038a1.126,1.126,0,0,1,.1-.082c.077-.058.159-.106.159-.106a.126.126,0,1,1,.127.215,1.5,1.5,0,0,0-.134.092c-.033.024-.065.051-.089.072l-.038.035a.127.127,0,0,1-.174,0,.126.126,0,0,1,.009-.174Z"
              transform="translate(-226.422 -157.226)"
              fill="#69402a"
            />
            <path
              id="Path_35711"
              data-name="Path 35711"
              d="M257.9,179.909l.056-.017c.035-.01.08-.023.127-.033a1.6,1.6,0,0,1,.185-.033.117.117,0,0,1,.131.1.115.115,0,0,1-.1.129,1.642,1.642,0,0,0-.162.033l-.11.031-.049.017a.122.122,0,0,1-.157-.073.12.12,0,0,1,.075-.155Z"
              transform="translate(-229.259 -156.196)"
              fill="#69402a"
            />
            <path
              id="Path_35712"
              data-name="Path 35712"
              d="M261.934,179.773h.058a.759.759,0,0,1,.127.017,1.67,1.67,0,0,1,.174.04.1.1,0,0,1,.072.122.1.1,0,0,1-.117.073s-.084-.017-.174-.028l-.115-.01H261.9a.11.11,0,0,1-.1-.115.108.108,0,0,1,.113-.1Z"
              transform="translate(-232.545 -156.15)"
              fill="#69402a"
            />
            <path
              id="Path_35713"
              data-name="Path 35713"
              d="M266.078,180.826l.051.024.112.059c.08.044.157.092.157.092a.072.072,0,0,1,.023.1.073.073,0,0,1-.094.026s-.077-.04-.155-.075l-.11-.045-.051-.019a.088.088,0,1,1,.061-.164Z"
              transform="translate(-235.975 -157.016)"
              fill="#69402a"
            />
            <path
              id="Path_35714"
              data-name="Path 35714"
              d="M247.8,183.695a.175.175,0,0,1-.051,0,10.821,10.821,0,0,1-1.722-1.745.129.129,0,0,1,.014-.174.127.127,0,0,1,.174.016,12.574,12.574,0,0,0,1.588,1.663,38.227,38.227,0,0,0,3.908-2.685c.187-.173,2.512-3.606,2.7-4.048a17.442,17.442,0,0,0-1.471-1.478.128.128,0,0,1,.174-.187,8,8,0,0,1,1.558,1.64c.009.066.019.166-1.328,2.17-.543.806-1.354,1.987-1.462,2.094s-1.047.79-1.982,1.453C248.27,183.554,247.921,183.695,247.8,183.695Z"
              transform="translate(-219.504 -152.232)"
              fill="#69402a"
            />
            <path
              id="Path_35715"
              data-name="Path 35715"
              d="M248.907,184.769a.174.174,0,0,1-.044,0h-.026a.129.129,0,0,1-.072-.174.127.127,0,0,1,.147-.077,1.248,1.248,0,0,0,.232-.117.127.127,0,1,1,.126.22A.806.806,0,0,1,248.907,184.769Zm.023-.249-.045.119Zm-.324.026a.129.129,0,0,1-.087-.035c-.073-.07-.159-.155-.255-.255a.127.127,0,0,1,0-.174.126.126,0,0,1,.174,0c.094.1.174.174.248.248a.126.126,0,0,1,0,.174A.129.129,0,0,1,248.6,184.546Zm.905-.1a.127.127,0,0,1-.068-.234c.091-.058.19-.124.295-.194a.127.127,0,1,1,.141.211l-.3.2A.137.137,0,0,1,249.51,184.448Zm.591-.394a.127.127,0,0,1-.072-.232l.291-.2a.127.127,0,0,1,.145.208l-.293.2A.124.124,0,0,1,250.1,184.054Zm-1.991-.019a.129.129,0,0,1-.094-.04c-.082-.089-.164-.174-.239-.265a.128.128,0,1,1,.188-.174c.075.085.155.174.237.263a.126.126,0,0,1-.092.211Zm2.573-.394a.131.131,0,0,1-.1-.054.126.126,0,0,1,.031-.174l.288-.206a.126.126,0,0,1,.148.2l-.29.208A.131.131,0,0,1,250.684,183.641Zm-3.048-.141a.131.131,0,0,1-.1-.042l-.234-.272a.127.127,0,0,1,.014-.174.129.129,0,0,1,.174.014s.092.11.232.269a.129.129,0,0,1-.012.174.126.126,0,0,1-.079.037Zm3.625-.274a.127.127,0,0,1-.1-.052.126.126,0,0,1,.028-.174l.286-.209a.127.127,0,1,1,.15.2l-.288.211a.131.131,0,0,1-.073.026Zm.572-.422a.126.126,0,0,1-.1-.051.127.127,0,0,1,.026-.174l.284-.211a.127.127,0,1,1,.152.2l-.286.213a.12.12,0,0,1-.075.026Zm.569-.426a.127.127,0,0,1-.077-.229c.185-.14.216-.174.222-.174a.291.291,0,0,0,.028-.035.131.131,0,0,1,.174-.021.127.127,0,0,1,.019.174.367.367,0,0,1-.056.065,1.7,1.7,0,0,1-.239.188.124.124,0,0,1-.072.037Zm.485-.523a.131.131,0,0,1-.073-.024.124.124,0,0,1-.028-.174l.2-.283a.127.127,0,0,1,.174-.03.126.126,0,0,1,.03.174l-.2.3a.127.127,0,0,1-.1.052Zm.413-.579a.129.129,0,0,1-.1-.2c.066-.092.134-.19.2-.291a.127.127,0,0,1,.208.145l-.2.293a.127.127,0,0,1-.1.066Zm.4-.584a.124.124,0,0,1-.072-.023.126.126,0,0,1-.031-.174c.066-.1.134-.194.2-.293a.126.126,0,0,1,.174-.031.124.124,0,0,1,.033.174l-.2.295a.129.129,0,0,1-.1.065Zm.4-.586a.124.124,0,0,1-.072-.023.127.127,0,0,1-.033-.174l.2-.279a.127.127,0,0,1,.174-.035.129.129,0,0,1,.035.174l-.209.293a.131.131,0,0,1-.1.056Zm.4-.59a.115.115,0,0,1-.07-.023.124.124,0,0,1-.035-.174l.2-.3a.127.127,0,1,1,.211.14c-.061.094-.127.194-.2.3a.127.127,0,0,1-.1.07Zm.4-.584a.12.12,0,0,1-.068-.021.126.126,0,0,1-.038-.174c.075-.117.138-.216.187-.3a.126.126,0,1,1,.216.131c-.051.084-.115.187-.19.3A.126.126,0,0,1,254.907,178.93Zm.326-.618a.127.127,0,0,1-.112-.066,1.711,1.711,0,0,0-.208-.248.129.129,0,0,1,0-.174.127.127,0,0,1,.174,0,1.569,1.569,0,0,1,.244.3.127.127,0,0,1-.11.187Zm-.475-.523a.119.119,0,0,1-.089-.038l-.253-.248a.123.123,0,0,1,.174-.174c.085.084.174.174.255.251a.124.124,0,0,1,0,.174.119.119,0,0,1-.1.031Zm-.509-.5a.129.129,0,0,1-.087-.035l-.267-.248a.126.126,0,0,1,0-.174.127.127,0,0,1,.174,0l.26.244a.127.127,0,0,1,0,.174.124.124,0,0,1-.089.035Z"
              transform="translate(-220.558 -153.701)"
              fill="#69402a"
            />
            <rect
              id="Rectangle_18233"
              data-name="Rectangle 18233"
              width="0.914"
              height="0.382"
              rx="0.191"
              transform="translate(31.074 27.966) rotate(-44.21)"
              fill="#69402a"
            />
            <path
              id="Path_35716"
              data-name="Path 35716"
              d="M256.62,181.492c-.08-.349-.626-.387-.926-.406s-.075.295.016.384-.2.016-.511.082-.633.553-.314.724,1.031-.5,1.143-.49S256.682,181.768,256.62,181.492Z"
              transform="translate(-226.727 -157.237)"
              fill="#f7b690"
            />
            <path
              id="Path_35717"
              data-name="Path 35717"
              d="M165.036,116.9a.1.1,0,0,1-.07-.03.1.1,0,0,1,0-.136c.267-.248,1.628-1.668,1.628-2.443a.1.1,0,1,1,.192,0c0,.843-1.354,2.268-1.689,2.587A.094.094,0,0,1,165.036,116.9Z"
              transform="translate(-152.583 -102.021)"
              fill="#2a95bf"
            />
            <path
              id="Path_35718"
              data-name="Path 35718"
              d="M192.988,113.579a.1.1,0,0,1-.072-.033.094.094,0,0,1,.009-.134,23.225,23.225,0,0,0,.269-4.335c0-.508.012-.872.023-1.022a1.3,1.3,0,0,1,.389-.731,2.207,2.207,0,0,0,.6-1.251,5.127,5.127,0,0,0-.37-1.717,14.111,14.111,0,0,1-.6-2.39.1.1,0,1,1,.188-.026,13.945,13.945,0,0,0,.591,2.359,5.081,5.081,0,0,1,.377,1.8,2.39,2.39,0,0,1-.644,1.35,1.257,1.257,0,0,0-.349.623c-.009.141-.014.523-.021,1.01-.033,2.678-.1,4.269-.333,4.477A.1.1,0,0,1,192.988,113.579Z"
              transform="translate(-175.66 -91.819)"
              fill="#2a95bf"
            />
            <path
              id="Path_35719"
              data-name="Path 35719"
              d="M193.755,104.453c-.054.033-.063.133-.04.218s.077.159.15.134.073-.127.04-.218S193.805,104.42,193.755,104.453Z"
              transform="translate(-176.329 -93.967)"
              fill="#f7f6f1"
            />
            <path
              id="Path_35720"
              data-name="Path 35720"
              d="M194.781,108.958a.124.124,0,0,0-.045.091.336.336,0,0,0,.016.129c.026.084.085.154.157.126a.091.091,0,0,0,.056-.085.349.349,0,0,0-.1-.246A.065.065,0,0,0,194.781,108.958Z"
              transform="translate(-177.181 -97.686)"
              fill="#f7f6f1"
            />
            <path
              id="Path_35721"
              data-name="Path 35721"
              d="M195.8,112.957a.124.124,0,0,0-.042.091.3.3,0,0,0,.016.129c.028.084.087.152.159.124a.087.087,0,0,0,.054-.085.3.3,0,0,0-.028-.134.312.312,0,0,0-.075-.11A.066.066,0,0,0,195.8,112.957Z"
              transform="translate(-178.021 -100.987)"
              fill="#f7f6f1"
            />
            <path
              id="Path_35722"
              data-name="Path 35722"
              d="M196.846,116.643a.124.124,0,0,0-.047.089.328.328,0,0,0,.01.129c.024.085.08.155.154.131a.087.087,0,0,0,.058-.082.293.293,0,0,0-.021-.136.316.316,0,0,0-.072-.113A.065.065,0,0,0,196.846,116.643Z"
              transform="translate(-178.884 -104.031)"
              fill="#f7f6f1"
            />
            <path
              id="Path_35723"
              data-name="Path 35723"
              d="M197.7,120.312a.12.12,0,0,0-.058.084.349.349,0,0,0,0,.129c.016.087.065.162.14.147a.092.092,0,0,0,.066-.078.307.307,0,0,0-.009-.136.3.3,0,0,0-.059-.12C197.746,120.311,197.718,120.3,197.7,120.312Z"
              transform="translate(-179.576 -107.062)"
              fill="#f7f6f1"
            />
            <path
              id="Path_35724"
              data-name="Path 35724"
              d="M198.055,124.185a.115.115,0,0,0-.066.075.3.3,0,0,0-.021.127c0,.087.04.174.117.164a.092.092,0,0,0,.077-.066.317.317,0,0,0,.01-.136.3.3,0,0,0-.04-.127C198.111,124.19,198.085,124.174,198.055,124.185Z"
              transform="translate(-179.85 -110.261)"
              fill="#f7f6f1"
            />
            <path
              id="Path_35725"
              data-name="Path 35725"
              d="M197.415,128.49a.117.117,0,0,0-.092.04.332.332,0,0,0-.073.106c-.035.082-.037.174.035.2a.092.092,0,0,0,.1-.03.293.293,0,0,0,.066-.117.308.308,0,0,0,.017-.133C197.462,128.519,197.446,128.493,197.415,128.49Z"
              transform="translate(-179.238 -113.817)"
              fill="#f7f6f1"
            />
            <path
              id="Path_35726"
              data-name="Path 35726"
              d="M195.542,131.51a.124.124,0,0,0-.1.016.349.349,0,0,0-.1.087c-.054.07-.077.157-.012.2a.092.092,0,0,0,.1,0,.305.305,0,0,0,.094-.1.288.288,0,0,0,.047-.124C195.58,131.55,195.571,131.522,195.542,131.51Z"
              transform="translate(-177.643 -116.307)"
              fill="#f7f6f1"
            />
            <path
              id="Path_35727"
              data-name="Path 35727"
              d="M193.823,134.73a.12.12,0,0,0-.091.045.335.335,0,0,0-.065.112c-.03.082-.026.174.047.2a.092.092,0,0,0,.1-.035.3.3,0,0,0,.061-.122.321.321,0,0,0,.009-.133C193.872,134.756,193.854,134.732,193.823,134.73Z"
              transform="translate(-176.286 -118.969)"
              fill="#f7f6f1"
            />
            <path
              id="Path_35728"
              data-name="Path 35728"
              d="M193.247,139.056a.124.124,0,0,0-.079.066.335.335,0,0,0-.038.122c0,.087.016.174.092.174a.092.092,0,0,0,.085-.056.349.349,0,0,0,0-.263C193.3,139.072,193.282,139.044,193.247,139.056Z"
              transform="translate(-175.857 -122.538)"
              fill="#f7f6f1"
            />
            <path
              id="Path_35729"
              data-name="Path 35729"
              d="M193.039,142.867a.127.127,0,0,0-.079.065.349.349,0,0,0-.038.124c-.009.087.016.174.092.174a.092.092,0,0,0,.085-.056.335.335,0,0,0,.009-.263C193.093,142.89,193.07,142.862,193.039,142.867Z"
              transform="translate(-175.683 -125.686)"
              fill="#f7f6f1"
            />
            <path
              id="Path_35730"
              data-name="Path 35730"
              d="M192.866,146.867a.122.122,0,0,0-.079.065.349.349,0,0,0-.038.122c-.01.089.014.174.089.174a.094.094,0,0,0,.087-.056.309.309,0,0,0,.031-.133.3.3,0,0,0-.021-.131C192.92,146.89,192.9,146.862,192.866,146.867Z"
              transform="translate(-175.54 -128.988)"
              fill="#f7f6f1"
            />
            <path
              id="Path_35731"
              data-name="Path 35731"
              d="M192.681,151a.117.117,0,0,0-.08.063.349.349,0,0,0-.042.122c-.01.087.012.174.089.174a.089.089,0,0,0,.085-.054.286.286,0,0,0,.035-.131.3.3,0,0,0-.019-.131A.075.075,0,0,0,192.681,151Z"
              transform="translate(-175.383 -132.4)"
              fill="#f7f6f1"
            />
            <path
              id="Path_35732"
              data-name="Path 35732"
              d="M192.463,155.206a.119.119,0,0,0-.08.061.3.3,0,0,0-.045.12c-.014.087,0,.174.084.185a.092.092,0,0,0,.087-.052.311.311,0,0,0,.038-.131.307.307,0,0,0-.016-.131C192.517,155.224,192.495,155.2,192.463,155.206Z"
              transform="translate(-175.199 -135.872)"
              fill="#f7f6f1"
            />
            <path
              id="Path_35733"
              data-name="Path 35733"
              d="M192.191,159.408a.126.126,0,0,0-.084.058.336.336,0,0,0-.047.12c-.017.087,0,.174.077.187a.094.094,0,0,0,.091-.049.33.33,0,0,0,.04-.131.316.316,0,0,0-.01-.131C192.246,159.428,192.219,159.4,192.191,159.408Z"
              transform="translate(-174.969 -139.341)"
              fill="#f7f6f1"
            />
            <path
              id="Path_35734"
              data-name="Path 35734"
              d="M191.831,163.54a.12.12,0,0,0-.085.056.31.31,0,0,0-.052.117c-.021.087,0,.174.07.19a.093.093,0,0,0,.092-.045.349.349,0,0,0,.04-.26C191.884,163.56,191.863,163.538,191.831,163.54Z"
              transform="translate(-174.664 -142.752)"
              fill="#f7f6f1"
            />
            <path
              id="Path_35735"
              data-name="Path 35735"
              d="M191.349,167.53a.119.119,0,0,0-.087.052.3.3,0,0,0-.059.115c-.024.084-.016.174.059.192a.094.094,0,0,0,.1-.04.348.348,0,0,0,.052-.126.307.307,0,0,0,0-.133C191.4,167.554,191.38,167.53,191.349,167.53Z"
              transform="translate(-174.255 -146.046)"
              fill="#f7f6f1"
            />
          </g>
          <g id="character3" transform="translate(817.914 328.847)">
            <path
              id="Path_35994"
              data-name="Path 35994"
              d="M1039.768,470.961c.058-.084.5-.209.638-.385a2.276,2.276,0,0,0-.632-3.085c-.638-.35-1.274.113-1.944-.073-.332-.091-.542-.443-.871-.545a2.607,2.607,0,0,0-3.323,2.375,4.312,4.312,0,0,1-.152,1.146c-.381.852-1.653.838-2.273,1.534-.98,1.1.218,2.878-2.94,3.519-.94.192-1.267.388-1.33,1.589a1.092,1.092,0,0,0,.09.626,2.719,2.719,0,0,0,3.375.434c.739-.411.986-1.49,1.816-1.653,1.266-.248,2.8.3,3.734-.587a5.72,5.72,0,0,0,.946-1.944C1037.506,472.573,1038.975,472.14,1039.768,470.961Z"
              transform="translate(-1014.901 -466.745)"
              fill="#222b54"
            />
            <path
              id="Path_35995"
              data-name="Path 35995"
              d="M1070.211,647.175a92.673,92.673,0,0,1-3.457-15.549c0-1.339-1.8-15.733-2.979-17.011-1.35-1.461-6.19,1.371-6.217,2.332-.029,1.025,2.416,7.237,4.863,13.937.33.906-.334,4.438,0,5.344,2.453,6.668,5.969,10.371,6.184,11.285C1068.714,647.972,1070.329,647.475,1070.211,647.175Z"
              transform="translate(-1040.865 -591.738)"
              fill="#222b54"
            />
            <path
              id="Path_35996"
              data-name="Path 35996"
              d="M986.2,602.679a13.374,13.374,0,0,1-4.142-3.2c-1.839,2.133-3.28,3.795-3.5,6.792-.084,1.089.338,11.041-.161,11.666-.136.169-3.78,1.458-5.3,2.8-2.846,2.518-4.056,7.008-5.349,7.922-.382.271.742,1.361.893,1.228,2.617-2.311,12.459-9.168,13.786-10.477C983.44,618.4,986.538,602.836,986.2,602.679Z"
              transform="translate(-964.665 -579.258)"
              fill="#222b54"
            />
            <path
              id="Path_35997"
              data-name="Path 35997"
              d="M954.608,790.447c-.483.3-2.314.742-2.473,1.181-.35.963.27,1.164.693,2.072.187.4.248.651.457,1.066.556,1.114.83,1.463.935,1.676.087.183.314-.51.375-1.147a7.858,7.858,0,0,1,.858-3.69C955.547,791.483,954.922,790.246,954.608,790.447Z"
              transform="translate(-951.416 -741.112)"
              fill="#f7b690"
            />
            <path
              id="Path_35998"
              data-name="Path 35998"
              d="M950.783,791.92c-.052-.251-2.883.9-2.794,1.048.187.334,1.787,3.263,1.9,3.5s1.194,2.09,1.277,2.261c.21.44.565.012.513-.483a6.294,6.294,0,0,1-.372-2.029c0-.171-1.03-.268-1.36-.117-.152-.271-.989-2.438-.789-2.742C949.38,793.005,950.823,792.126,950.783,791.92Z"
              transform="translate(-947.987 -742.349)"
              fill="#0a3c5f"
            />
            <path
              id="Path_35999"
              data-name="Path 35999"
              d="M1128.664,830.308c.027.57-.5,1.918-.2,2.272.667.779,1.147.337,2.145.416.443.035.693.065,1.161.126a6.993,6.993,0,0,0,1.924.011c.184.012.031-.361-.439-.672-.833-.555-2.412-1.353-3.065-2.572C1130.13,829.771,1128.648,829.93,1128.664,830.308Z"
              transform="translate(-1100.89 -774.531)"
              fill="#f7b690"
            />
            <path
              id="Path_36000"
              data-name="Path 36000"
              d="M1127.657,832.84c-.242-.082-.547,2.579-.457,2.723s3.7.271,3.961.3,2.407-.014,2.59,0c.488.032.288-.487-.167-.687a15.266,15.266,0,0,1-1.95-.672c-.318-.14-.3.652-.239,1.181-.3,0-3.135-.387-3.306-.711C1127.918,834.593,1127.857,832.907,1127.657,832.84Z"
              transform="translate(-1099.883 -777.063)"
              fill="#0a3c5f"
            />
            <path
              id="Path_36001"
              data-name="Path 36001"
              d="M1086.253,525.259a21.672,21.672,0,0,0,1.024,7.535c.264.609,5.614,5.18,5.614,5.18s-.318.591-.713.527a12.918,12.918,0,0,1-6.792-4.333,11.712,11.712,0,0,1-2.2-7.688C1083.668,522.478,1086.462,523.326,1086.253,525.259Z"
              transform="translate(-1062.541 -514.973)"
              fill="#f7b690"
            />
            <path
              id="Path_36002"
              data-name="Path 36002"
              d="M1136.2,613.251a20.878,20.878,0,0,1,2.768,1.495c.262.244.743,1.444.551,1.371-.375-.143-.669-.894-.8-.995s.373,1.556.218,1.523c-.448-.093-.529-1.231-.669-1.269-.088-.024.046,1.361-.108,1.3-.375-.152-.232-1.219-.344-1.1s-.244,1.019-.369.958c-.335-.165.035-.844-.087-.958s-1.45-.5-1.613-.782a1.986,1.986,0,0,1-.094-1.159C1135.727,613.445,1135.9,613.12,1136.2,613.251Z"
              transform="translate(-1107.02 -590.905)"
              fill="#f7b690"
            />
            <path
              id="Path_36003"
              data-name="Path 36003"
              d="M1142.487,617.807a1.068,1.068,0,0,1-.5-.152c-.05-.034-.093-.067-.13-.1-.117-.093-.152-.117-.256-.062a1.071,1.071,0,0,0-.129.09.568.568,0,0,1-.532.14.073.073,0,1,1,.031-.143.42.42,0,0,0,.411-.113,1.281,1.281,0,0,1,.152-.1.325.325,0,0,1,.416.075c.037.029.075.059.119.088a.738.738,0,0,0,.507.113s.009,0,0-.032c-.032-.117-.3-.3-.559-.474a4.241,4.241,0,0,1-.5-.37.073.073,0,0,1,.1-.105,4.046,4.046,0,0,0,.477.355c.3.207.57.385.617.555a.165.165,0,0,1-.057.189A.289.289,0,0,1,1142.487,617.807Z"
              transform="translate(-1111.493 -593.811)"
              fill="#d48570"
            />
            <path
              id="Path_36004"
              data-name="Path 36004"
              d="M1027.622,543.868a.168.168,0,0,1-.131-.271c4.031-5.124,4.962-8.085,5.789-10.7.2-.609.378-1.2.6-1.79a.166.166,0,0,1,.3.114c-.215.583-.4,1.162-.59,1.776-.829,2.642-1.769,5.637-5.838,10.806A.17.17,0,0,1,1027.622,543.868Z"
              transform="translate(-1015.348 -521.235)"
              fill="#cc346f"
            />
            <path
              id="Path_36005"
              data-name="Path 36005"
              d="M1053.726,515.655a11.8,11.8,0,0,0-1.953-3.14c-.689-.585-3.311,2.6-3.764,4.126-.355,1.2-.1,7.4-.282,8.049-.557,2.02-3.327,4.113-2.614,4.372,3.763,1.383,7.456,1.117,8.059.011.271-.5-.344-2.4-.11-4.389.286-2.438.762-5.014,1.057-5.287C1055.613,518.021,1054.059,516.375,1053.726,515.655Z"
              transform="translate(-1030.216 -505.482)"
              fill="#fdd247"
            />
            <path
              id="Path_36006"
              data-name="Path 36006"
              d="M1049.969,529.869a14.916,14.916,0,0,1-4.991-.937.183.183,0,0,1-.125-.125c-.062-.233.32-.692.85-1.327a9.042,9.042,0,0,0,1.874-2.95,25.316,25.316,0,0,0,.073-2.911,32.727,32.727,0,0,1,.209-5.137c.382-1.29,2.38-3.88,3.4-4.187a.407.407,0,0,1,.4.049,11.848,11.848,0,0,1,1.959,3.148,4.859,4.859,0,0,0,.276.475c.538.858,1.348,2.156.111,3.294-.265.245-.736,2.61-1.05,5.271a12.836,12.836,0,0,0,.093,2.956,3.251,3.251,0,0,1,.015,1.444C1052.745,529.52,1051.561,529.869,1049.969,529.869Zm1.469-17.554a.59.59,0,0,0-.161.026c-1.013.3-2.991,2.873-3.372,4.155a32.816,32.816,0,0,0-.207,5.124,25.03,25.03,0,0,1-.075,2.924,9.159,9.159,0,0,1-1.883,2.969c-.5.6-.9,1.066-.841,1.283a.136.136,0,0,0,.1.091c3.71,1.371,7.427,1.127,8.029.023a3.333,3.333,0,0,0-.02-1.417,12.49,12.49,0,0,1-.093-2.965c.28-2.383.762-5.017,1.066-5.3,1.208-1.112.41-2.389-.119-3.233a5.155,5.155,0,0,1-.28-.481,11.545,11.545,0,0,0-1.946-3.131A.286.286,0,0,0,1051.438,512.315Z"
              transform="translate(-1030.089 -505.329)"
              fill="#828feb"
            />
            <path
              id="Path_36007"
              data-name="Path 36007"
              d="M1004.515,614.216c-.567.218-4.165,5.459-4.127,6.035s4.766,3.719,5.942,2.809c.12-.093,3.39-6.379,3.181-6.908S1005.061,614.006,1004.515,614.216Z"
              transform="translate(-992.404 -591.732)"
              fill="#8a1c46"
            />
            <path
              id="Path_36008"
              data-name="Path 36008"
              d="M1082.378,498.571c0,.361.914,2.438.553,2.951-.219.3-2.3-.853-2.942-2.311-.41-.932.107-1.088.35-1.455a3.027,3.027,0,0,0,.774-2.826,9.223,9.223,0,0,1,2.145.225A23.03,23.03,0,0,0,1082.378,498.571Z"
              transform="translate(-1059.749 -490.599)"
              fill="#f7b690"
            />
            <path
              id="Path_36009"
              data-name="Path 36009"
              d="M1090.984,486.939c.271,1.3-.408,4.057-1.261,4.209a2.832,2.832,0,0,1-2.329-2.624c-.3.014-.256-1.018-.067-1.164s.415,0,.4.4a4.759,4.759,0,0,0,2.6-.7C1090.6,486.869,1090.919,486.725,1090.984,486.939Z"
              transform="translate(-1065.969 -483.772)"
              fill="#f7b690"
            />
            <path
              id="Path_36010"
              data-name="Path 36010"
              d="M1057.016,544.408a.163.163,0,0,1-.113-.044.168.168,0,0,1-.009-.236,30.254,30.254,0,0,0,5.844-10.182c.964-3.009.957-4.089.781-4.465a.168.168,0,0,1,.3-.142c.3.635.047,2.176-.762,4.709a30.539,30.539,0,0,1-5.916,10.307.169.169,0,0,1-.131.053Z"
              transform="translate(-1040.264 -519.72)"
              fill="#cc346f"
            />
            <path
              id="Path_36011"
              data-name="Path 36011"
              d="M1064.815,534.35c.4,1.7-.809,6.475-.489,8.09.171.862,1.429,4.094,2.227,7.825.277,1.29-1.066.4-1.066.4s-3.519-6.123-3.73-7.185c-.216-1.1.235-5.7.617-8.254C1062.708,533.055,1064.479,532.93,1064.815,534.35Z"
              transform="translate(-1044.376 -523.258)"
              fill="#f7b690"
            />
            <path
              id="Path_36012"
              data-name="Path 36012"
              d="M1084.949,643.5a23.73,23.73,0,0,1,.774,3.138c-.012.357-.6,1.51-.672,1.316-.139-.378.235-1.091.224-1.258s-.929,1.3-1.005,1.166c-.224-.4.58-1.208.518-1.338-.04-.082-1,.928-1.05.762-.126-.385.771-.977.609-.981s-.928.484-.964.35c-.1-.361.661-.527.666-.695s-.574-1.423-.469-1.731a2,2,0,0,1,.814-.832C1084.587,643.331,1084.85,643.189,1084.949,643.5Z"
              transform="translate(-1062.748 -616.408)"
              fill="#f7b690"
            />
          </g>
          <g id="character14" transform="translate(876.86 328.847)">
            <path
              id="Path_35736"
              data-name="Path 35736"
              d="M604.2,228.612c.322-.111,1.337-1.221,1.556-1.274a27.139,27.139,0,0,1,2.8,4.933c-.058.261-2.9-2.256-2.9-2.256Z"
              transform="translate(-557.247 -194.958)"
              fill="#b3744b"
            />
            <path
              id="Path_35737"
              data-name="Path 35737"
              d="M614.773,240.88a.1.1,0,0,1-.09-.069.865.865,0,0,1,.421-.986.1.1,0,1,1,.087.169.681.681,0,0,0-.322.765.1.1,0,0,1-.065.118Z"
              transform="translate(-566.015 -205.425)"
              fill="#0f1638"
            />
            <path
              id="Path_35738"
              data-name="Path 35738"
              d="M617.193,243.416a.094.094,0,0,1-.089-.06.745.745,0,0,1,.379-.92.1.1,0,1,1,.106.161.576.576,0,0,0-.308.693.093.093,0,0,1-.055.122A.084.084,0,0,1,617.193,243.416Z"
              transform="translate(-568.031 -207.611)"
              fill="#0f1638"
            />
            <path
              id="Path_35739"
              data-name="Path 35739"
              d="M619.673,246a.1.1,0,0,1-.084-.052.543.543,0,0,1,0-.5.7.7,0,0,1,.4-.358.1.1,0,1,1,.035.187.541.541,0,0,0-.269.253.359.359,0,0,0,0,.334.1.1,0,0,1-.042.129A.1.1,0,0,1,619.673,246Z"
              transform="translate(-570.105 -209.85)"
              fill="#0f1638"
            />
            <path
              id="Path_35740"
              data-name="Path 35740"
              d="M324.687,374.45c-.222.277-.495,1.821-.657,1.99a27.947,27.947,0,0,1-5.219-2.786c-.1-.271,3.82.374,3.82.374Z"
              transform="translate(-317.838 -317.645)"
              fill="#94572f"
            />
            <path
              id="Path_35741"
              data-name="Path 35741"
              d="M341.942,376.791a.1.1,0,0,1-.032,0,.1.1,0,0,1-.056-.122.732.732,0,0,0-.2-.775.1.1,0,0,1-.008-.135.1.1,0,0,1,.134-.008.917.917,0,0,1,.255.984A.092.092,0,0,1,341.942,376.791Z"
              transform="translate(-336.972 -319.439)"
              fill="#0f1638"
            />
            <path
              id="Path_35742"
              data-name="Path 35742"
              d="M337.9,376.216h-.027a.1.1,0,0,1-.063-.119.943.943,0,0,0-.24-.843.093.093,0,0,1-.034-.129.1.1,0,0,1,.131-.034,1.087,1.087,0,0,1,.322,1.06A.1.1,0,0,1,337.9,376.216Z"
              transform="translate(-333.533 -318.895)"
              fill="#0f1638"
            />
            <path
              id="Path_35743"
              data-name="Path 35743"
              d="M334.3,375.569a.1.1,0,0,1-.031,0,.1.1,0,0,1-.06-.121.711.711,0,0,0-.174-.72.1.1,0,1,1,.106-.161.888.888,0,0,1,.248.939.1.1,0,0,1-.09.063Z"
              transform="translate(-330.574 -318.453)"
              fill="#0f1638"
            />
            <path
              id="Path_35744"
              data-name="Path 35744"
              d="M400.79,67.008a15.909,15.909,0,0,0-2.059,2.417c-.356.4,7.788-1.772,7.067-1.895-1.189-.2-1.983-1.73-2.726-1.321A7.428,7.428,0,0,1,400.79,67.008Z"
              transform="translate(-384.873 -59.732)"
              fill="#b3ae9e"
            />
            <path
              id="Path_35745"
              data-name="Path 35745"
              d="M340.492,87.957c-1.2,3.04-3.545,7.16-5.173,7.977-1.953.98-9.64-2.828-9.678-4.917,1.785-.269,7.558,1.308,8.294,1.176.363-.064,1.718-3.061,3.282-5.937C338.931,83.112,341.46,85.508,340.492,87.957Z"
              transform="translate(-323.568 -75.348)"
              fill="#74758a"
            />
            <path
              id="Path_35746"
              data-name="Path 35746"
              d="M380.763,191.284c-1.471.274-2.889,2.12-3.118,1.946-2.849-2.169-3.9-4.547-5.849-6.454-.711-.7-.63-2.426-4.3-3.706,0,0-8.217.875-8.262,1.03-1.593,6.532-5.175,15.317-5.509,17.066-1.128,5.871-5.281,12.6-5.8,13.221a1.389,1.389,0,0,0,.9,1.05c2.882-1.545,9.862-8.571,10.6-11.95.209-.967-.288-2.341.016-3.308,1.181-3.744,4.63-6.752,6.364-9.63,2.853,2.57,7.611,7.2,10.244,8.236,2.246.881,13.916-6.081,13.975-6.54a1.393,1.393,0,0,0-.417-1.038A31.925,31.925,0,0,0,380.763,191.284Z"
              transform="translate(-342.267 -157.823)"
              fill="#2e4b5f"
            />
            <path
              id="Path_35747"
              data-name="Path 35747"
              d="M393.965,77.246c-1.378-1.3.583-8.035,1.534-8.837,1.416-1.2,2.9-2.955,3.8-1.816a2.029,2.029,0,0,0,.746.644c.714.369,2.684.659,3.222,2.256A41.413,41.413,0,0,1,404.8,80.544c.034,2.475,1.432,3.45,1.128,4.2-.512,1.289-7.205,3.654-8.311,2.4C395.591,84.846,394.479,77.733,393.965,77.246Z"
              transform="translate(-380.487 -59.804)"
              fill="#e6e5e0"
            />
            <path
              id="Path_35748"
              data-name="Path 35748"
              d="M408.18,77.3a4.205,4.205,0,0,0,.026.825c-.366,1.821.224,9.488,3.991,13.07.778.74,3.662-.5,3.414-.595-4.3-1.7-7.133-10.887-6.928-12.274.023-.148.744-.52.715-.738-.048-.351-.511-.738-.7-.709S408.18,77.3,408.18,77.3Z"
              transform="translate(-392.753 -68.742)"
              fill="#2e4b5f"
            />
            <path
              id="Path_35749"
              data-name="Path 35749"
              d="M409.747,64.039c.522-.04.849.495.98.885.187.559-1.832,2.513-2.219,2.739-.2-.187-.525-1.408-.7-1.482-.258-.11-.806,1.237-.831,1.068a3.988,3.988,0,0,1,.644-1.687C407.822,65.4,409.269,64.074,409.747,64.039Z"
              transform="translate(-391.799 -57.968)"
              fill="#f7f6f1"
            />
            <path
              id="Path_35750"
              data-name="Path 35750"
              d="M435.359,82.376c-.242-2.961.593-8.989-.309-11.992-.263-.872-3.33-.5-4.672-1.466-.023-.016-.7-.538-.712-.512-.894,2.03,7.816,24.923,8.539,24.691,1.772-.569,3.524-3.545,4.057-3.891C441.164,88.1,435.626,85.727,435.359,82.376Z"
              transform="translate(-410.779 -61.632)"
              fill="#74758a"
            />
            <path
              id="Path_35751"
              data-name="Path 35751"
              d="M394.38,95.945c-.8-3-1.682-5.942-1.98-7.1-.371-1.432-1.66-6.385.361-9.129a11.952,11.952,0,0,0-2.153,2.3c-1.479,4.834,1.793,8.771,2.317,14.351.195,2.078-.611,4.511-1.41,6.625-.387,1.03,2.3,1.747,3.88,1.471C395.186,103.423,394.655,96.978,394.38,95.945Z"
              transform="translate(-377.75 -71.114)"
              fill="#74758a"
            />
            <path
              id="Path_35752"
              data-name="Path 35752"
              d="M547.832,137.1l-8.351,7.46a.864.864,0,0,1-1.241-.172l-4.761-6.052a.414.414,0,0,1,.026-.567l8.246-7.366a.414.414,0,0,1,.565.04l5.478,5.4a.865.865,0,0,1,.037,1.253Z"
              transform="translate(-497.837 -113.566)"
              fill="#945e40"
            />
            <path
              id="Path_35753"
              data-name="Path 35753"
              d="M605.071,149.133a.1.1,0,0,1-.077-.032l-.111-.11a.108.108,0,0,1,0-.161.111.111,0,0,1,.161,0l.111.11a.111.111,0,0,1,0,.161A.106.106,0,0,1,605.071,149.133Z"
              transform="translate(-557.789 -129.071)"
              fill="#69402a"
            />
            <path
              id="Path_35754"
              data-name="Path 35754"
              d="M554.54,161.841a.111.111,0,1,1,0-.222.388.388,0,0,0,.222-.084.11.11,0,0,1,.161.015.113.113,0,0,1-.016.161.6.6,0,0,1-.348.134Zm-.3-.064a.116.116,0,0,1-.052-.013.734.734,0,0,1-.24-.2l-.027-.034a.113.113,0,0,1,.019-.161.111.111,0,0,1,.161.018l.026.034a.505.505,0,0,0,.169.14.113.113,0,0,1-.052.211Zm.815-.251a.11.11,0,0,1-.082-.037.113.113,0,0,1,.008-.161l.232-.206a.113.113,0,0,1,.161.01.11.11,0,0,1-.01.161l-.235.208A.114.114,0,0,1,555.055,161.525Zm-1.237-.2a.111.111,0,0,1-.089-.043l-.192-.243a.113.113,0,0,1,.019-.161.111.111,0,0,1,.161.018l.192.245a.111.111,0,0,1-.019.161A.106.106,0,0,1,553.818,161.329Zm1.71-.217a.111.111,0,0,1-.074-.193l.23-.208a.111.111,0,0,1,.161.01.11.11,0,0,1,0,.161l-.232.208A.108.108,0,0,1,555.528,161.111Zm-2.094-.271a.11.11,0,0,1-.087-.043l-.192-.243a.112.112,0,0,1,.176-.139l.192.245a.113.113,0,0,1-.019.161A.109.109,0,0,1,553.433,160.841Zm2.549-.142a.11.11,0,0,1-.082-.037.111.111,0,0,1,.008-.161l.232-.206a.111.111,0,1,1,.148.161l-.232.206a.108.108,0,0,1-.074.032Zm-2.932-.346a.11.11,0,0,1-.087-.043l-.192-.243a.109.109,0,0,1,.019-.161.111.111,0,0,1,.161.018l.192.245a.113.113,0,0,1-.089.18Zm3.4-.068a.114.114,0,0,1-.084-.037.113.113,0,0,1,.01-.161l.23-.206a.111.111,0,1,1,.148.161l-.23.206A.111.111,0,0,1,556.446,160.285Zm.462-.414a.11.11,0,0,1-.082-.037.113.113,0,0,1,.008-.161l.232-.206a.111.111,0,0,1,.148.161l-.237.216a.115.115,0,0,1-.069.027Zm-4.242,0a.108.108,0,0,1-.087-.043l-.192-.243a.111.111,0,0,1,.018-.161.113.113,0,0,1,.161.018l.192.245a.113.113,0,0,1-.089.18Zm4.706-.408a.11.11,0,0,1-.084-.037.111.111,0,0,1,.008-.161l.232-.208a.111.111,0,0,1,.148.161l-.23.206a.112.112,0,0,1-.074.032Zm-5.09-.081a.108.108,0,0,1-.087-.044l-.192-.256a.111.111,0,1,1,.174-.139l.192.245a.111.111,0,0,1-.018.161.113.113,0,0,1-.069.026Zm5.552-.332a.114.114,0,0,1-.084-.037.111.111,0,0,1,.01-.161l.232-.206a.11.11,0,0,1,.161,0,.111.111,0,0,1,0,.161l-.232.206a.111.111,0,0,1-.087.031Zm.462-.414a.109.109,0,0,1-.082-.037.111.111,0,0,1,.008-.161l.232-.206a.111.111,0,1,1,.148.161l-.232.206a.108.108,0,0,1-.074.031Zm.464-.414a.115.115,0,0,1-.084-.037.11.11,0,0,1,.01-.161l.23-.208a.111.111,0,0,1,.161.01.109.109,0,0,1,0,.161l-.232.208a.117.117,0,0,1-.085.021Zm.462-.412a.1.1,0,0,1-.082-.039.11.11,0,0,1,.008-.161l.232-.208a.111.111,0,1,1,.148.161l-.232.206a.108.108,0,0,1-.074.034Zm.464-.414a.114.114,0,0,1-.084-.037.111.111,0,0,1,.01-.161l.23-.206a.111.111,0,1,1,.148.161l-.23.206a.111.111,0,0,1-.074.031Zm.462-.414a.115.115,0,0,1-.084-.037.113.113,0,0,1,.01-.161l.232-.206a.11.11,0,0,1,.161,0,.111.111,0,0,1,0,.161l-.232.206a.111.111,0,0,1-.087.031Zm.464-.414a.115.115,0,0,1-.084-.037.11.11,0,0,1,.008-.161l.232-.208a.113.113,0,0,1,.161.01.11.11,0,0,1-.01.161l-.238.2a.111.111,0,0,1-.069.027Zm.462-.412a.111.111,0,0,1-.074-.195l.232-.208a.111.111,0,0,1,.148.161l-.232.206a.111.111,0,0,1-.074.029Zm.462-.414a.11.11,0,0,1-.082-.037.111.111,0,0,1,.008-.161l.232-.206a.111.111,0,1,1,.148.161l-.232.2a.108.108,0,0,1-.074.035Zm.464-.414a.113.113,0,0,1-.113-.12.113.113,0,0,1,.039-.079l.23-.206a.113.113,0,0,1,.161.008.111.111,0,0,1,0,.161l-.232.206a.111.111,0,0,1-.085.023Zm.462-.414a.1.1,0,0,1-.082-.037.11.11,0,0,1,.008-.161l.232-.208a.111.111,0,0,1,.148.161l-.232.208a.106.106,0,0,1-.074.031Zm.464-.412a.114.114,0,0,1-.084-.037.111.111,0,0,1,.01-.161l.23-.208a.114.114,0,1,1,.151.171l-.23.206a.111.111,0,0,1-.077.023Zm.448-.427a.106.106,0,0,1-.058-.018.111.111,0,0,1-.037-.153.409.409,0,0,0,.06-.216v-.018a.111.111,0,0,1,.222-.008v.026a.644.644,0,0,1-.092.333.113.113,0,0,1-.1.047Zm-.016-.59a.113.113,0,0,1-.1-.053.445.445,0,0,0-.077-.1l-.114-.113a.114.114,0,0,1,.161-.161l.114.113a.689.689,0,0,1,.11.137.111.111,0,0,1-.035.153.116.116,0,0,1-.063.015Zm-.422-.454a.114.114,0,0,1-.079-.032l-.221-.217a.113.113,0,0,1,0-.161.111.111,0,0,1,.161,0l.221.218a.111.111,0,0,1,0,.161A.107.107,0,0,1,562.939,153.03Zm-.441-.437a.106.106,0,0,1-.079-.032l-.221-.217a.111.111,0,0,1,0-.161.113.113,0,0,1,.161,0l.221.219a.111.111,0,0,1,0,.161.118.118,0,0,1-.089.031Zm-.45-.438a.109.109,0,0,1-.077-.031l-.222-.219a.114.114,0,1,1,.161-.161l.221.217a.111.111,0,0,1,0,.161.107.107,0,0,1-.082.032Zm-.441-.435a.115.115,0,0,1-.079-.032l-.221-.218a.113.113,0,0,1,0-.161.111.111,0,0,1,.161,0l.221.217a.111.111,0,0,1,0,.161.108.108,0,0,1-.082.034Zm-.44-.435a.113.113,0,0,1-.079-.032l-.221-.217a.111.111,0,0,1,0-.161.113.113,0,0,1,.161,0l.221.219a.111.111,0,0,1,0,.161.118.118,0,0,1-.082.031Z"
              transform="translate(-513.441 -130.786)"
              fill="#69402a"
            />
            <path
              id="Path_35755"
              data-name="Path 35755"
              d="M550.383,198.947a.114.114,0,0,1-.089-.042l-.1-.122a.117.117,0,0,1,.1-.187.111.111,0,0,1,.077.044l.1.122a.111.111,0,0,1-.087.18Z"
              transform="translate(-511.925 -170.846)"
              fill="#69402a"
            />
            <path
              id="Path_35756"
              data-name="Path 35756"
              d="M545.357,142.49l-.047-.06-.053-.073a1.22,1.22,0,0,1-.071-.1,2.489,2.489,0,0,1-.161-.322l-.045-.1c-.015-.032-.026-.069-.04-.1a1.806,1.806,0,0,1-.072-.234c-.011-.042-.021-.085-.032-.129s-.015-.089-.023-.135a2.342,2.342,0,0,1-.027-.288,2.4,2.4,0,0,1,.066-.632l.019-.082.026-.079c.019-.055.034-.11.058-.161l.068-.161.085-.161a2.46,2.46,0,0,1,.448-.554,2.3,2.3,0,0,1,.6-.39,2.176,2.176,0,0,1,.664-.184l.082-.011h.243a2.728,2.728,0,0,1,.309.029.638.638,0,0,1,.145.026l.138.035a1.119,1.119,0,0,1,.13.04l.124.045a2.728,2.728,0,0,1,.412.208l.084.052.074.053.129.1a1.505,1.505,0,0,1,.161.147l.058.053a.161.161,0,0,1-.177.255h-.011l-.065-.032-.179-.093-.129-.058-.073-.034-.081-.031a2.81,2.81,0,0,0-.371-.116q-.105-.025-.213-.04l-.113-.016h-.116a2.331,2.331,0,0,0-.237,0c-.04,0-.081.01-.121.013l-.061.008-.061.011c-.04.01-.082.015-.122.027l-.121.035c-.04.013-.079.031-.119.045a.83.83,0,0,0-.116.053.768.768,0,0,0-.114.06c-.035.024-.076.044-.11.069l-.106.076-.1.085a2.011,2.011,0,0,0-.334.4,1.9,1.9,0,0,0-.213.462,2.077,2.077,0,0,0-.092.475,2.137,2.137,0,0,0,0,.227v.111a.34.34,0,0,0,.011.106,1.937,1.937,0,0,0,.031.2.382.382,0,0,0,.018.093c.008.031.014.058.023.087.026.114.061.206.085.287l.01.029.011.029.022.053.034.082.027.071a.157.157,0,0,1-.274.148Z"
              transform="translate(-507.404 -120.459)"
              fill="#945e40"
            />
            <path
              id="Path_35757"
              data-name="Path 35757"
              d="M548.014,160.89l-.081-.134-.081-.135a.065.065,0,0,1,.111-.066l.073.145.068.14a.052.052,0,0,1-.023.069.053.053,0,0,1-.068-.019Z"
              transform="translate(-509.971 -138.909)"
              fill="#69402a"
            />
            <path
              id="Path_35758"
              data-name="Path 35758"
              d="M546.579,157.181l-.01-.05c-.011-.029-.024-.066-.037-.1-.026-.076-.045-.161-.045-.161a.084.084,0,0,1,.161-.04s.016.076.035.15c.01.037.019.073.029.1l.013.045a.074.074,0,0,1-.048.1A.076.076,0,0,1,546.579,157.181Z"
              transform="translate(-508.833 -135.762)"
              fill="#69402a"
            />
            <path
              id="Path_35759"
              data-name="Path 35759"
              d="M546.06,153.326V153a.1.1,0,0,1,.195,0v.3a.092.092,0,0,1-.085.1.09.09,0,0,1-.109-.079Z"
              transform="translate(-508.475 -132.529)"
              fill="#69402a"
            />
            <path
              id="Path_35760"
              data-name="Path 35760"
              d="M546.1,149.369v-.05a.532.532,0,0,1,.023-.11c.018-.081.042-.161.042-.161a.105.105,0,0,1,.2.06s-.024.074-.042.145l-.023.1v.047a.1.1,0,0,1-.119.084A.1.1,0,0,1,546.1,149.369Z"
              transform="translate(-508.504 -129.219)"
              fill="#69402a"
            />
            <path
              id="Path_35761"
              data-name="Path 35761"
              d="M547.228,145.806l.023-.047c.013-.027.032-.063.053-.1.04-.071.085-.14.085-.14a.111.111,0,0,1,.161-.029.108.108,0,0,1,.029.151s-.042.063-.079.126c-.018.032-.035.064-.048.09l-.021.042a.108.108,0,0,1-.147.048.106.106,0,0,1-.056-.143Z"
              transform="translate(-509.447 -126.28)"
              fill="#69402a"
            />
            <path
              id="Path_35762"
              data-name="Path 35762"
              d="M549.357,142.878l.035-.037.079-.081c.06-.056.124-.106.124-.106a.109.109,0,0,1,.161.016.111.111,0,0,1-.016.161s-.058.045-.111.1l-.072.071-.032.034a.111.111,0,1,1-.161-.15Z"
              transform="translate(-511.211 -123.895)"
              fill="#69402a"
            />
            <path
              id="Path_35763"
              data-name="Path 35763"
              d="M552.414,140.855l.045-.026.1-.052c.074-.035.15-.066.15-.066a.11.11,0,0,1,.142.063.108.108,0,0,1-.061.14s-.068.027-.134.06c-.034.016-.066.034-.09.048l-.04.023a.11.11,0,1,1-.111-.19Z"
              transform="translate(-513.759 -122.283)"
              fill="#69402a"
            />
            <path
              id="Path_35764"
              data-name="Path 35764"
              d="M556.045,139.917l.05-.01.111-.019c.081-.013.161-.018.161-.018a.1.1,0,0,1,.016.2.645.645,0,0,0-.147.019l-.1.019-.045.01a.105.105,0,0,1-.05-.2Z"
              transform="translate(-516.781 -121.583)"
              fill="#69402a"
            />
            <path
              id="Path_35765"
              data-name="Path 35765"
              d="M559.914,139.864h.05l.111.013c.081.013.161.029.161.029a.093.093,0,0,1-.037.182s-.072-.013-.148-.021l-.1-.01H559.9a.1.1,0,1,1,.01-.195Z"
              transform="translate(-519.999 -121.576)"
              fill="#69402a"
            />
            <path
              id="Path_35766"
              data-name="Path 35766"
              d="M563.772,140.684l.048.018.1.04c.074.032.145.068.145.068a.077.077,0,0,1,.036.1.079.079,0,0,1-.1.035s-.069-.031-.14-.055c-.035-.014-.071-.026-.1-.035l-.045-.014a.085.085,0,1,1,.05-.161Z"
              transform="translate(-523.227 -122.259)"
              fill="#69402a"
            />
            <path
              id="Path_35767"
              data-name="Path 35767"
              d="M567.4,142.409l.129.09.126.092a.055.055,0,0,1-.061.092l-.134-.081-.132-.081a.068.068,0,1,1,.069-.114Z"
              transform="translate(-526.284 -123.698)"
              fill="#69402a"
            />
            <path
              id="Path_35768"
              data-name="Path 35768"
              d="M540.049,144.973a.2.2,0,0,1-.055-.01,13.982,13.982,0,0,1-1.943-2.156.111.111,0,0,1,.018-.161.114.114,0,0,1,.161.019,14.249,14.249,0,0,0,1.83,2.077,43.1,43.1,0,0,0,4.824-3.01c.2-.176,3.256-4.274,3.441-4.714a18.315,18.315,0,0,0-1.693-1.861.114.114,0,0,1,.161-.161A12.5,12.5,0,0,1,548.554,137c0,.06.015.182-1.684,2.491-.665.9-1.711,2.294-1.841,2.406s-1.274.886-2.428,1.629C540.61,144.815,540.186,144.973,540.049,144.973Z"
              transform="translate(-501.734 -117.467)"
              fill="#69402a"
            />
            <path
              id="Path_35769"
              data-name="Path 35769"
              d="M541.518,145.759a.171.171,0,0,1-.05,0,.406.406,0,0,1-.076-.037.113.113,0,0,1-.034-.161.11.11,0,0,1,.153-.034l.014.008a.849.849,0,0,0,.169-.066.111.111,0,0,1,.1.2A.679.679,0,0,1,541.518,145.759Zm.5-.222a.11.11,0,0,1-.1-.058.111.111,0,0,1,.044-.151c.081-.044.171-.1.269-.161a.111.111,0,0,1,.161.039.113.113,0,0,1-.04.153c-.1.058-.192.111-.274.161a.112.112,0,0,1-.063.018Zm-.806-.01a.113.113,0,0,1-.079-.032c-.064-.064-.139-.142-.219-.232a.11.11,0,0,1,0-.161.111.111,0,0,1,.161,0c.079.087.15.161.211.224a.11.11,0,0,1,0,.161.111.111,0,0,1-.073.04Zm1.345-.306a.113.113,0,0,1-.1-.053.109.109,0,0,1,.037-.153l.266-.161a.111.111,0,0,1,.161.035.113.113,0,0,1-.035.161l-.268.161a.11.11,0,0,1-.064.01Zm-1.772-.161a.112.112,0,0,1-.084-.039c-.068-.077-.137-.161-.2-.238a.113.113,0,0,1,.015-.161.111.111,0,0,1,.161.014l.2.235a.111.111,0,0,1-.01.161.121.121,0,0,1-.074.034Zm2.3-.176a.111.111,0,0,1-.06-.206l.263-.161a.116.116,0,1,1,.127.195l-.264.161a.116.116,0,0,1-.061.018Zm-2.7-.3a.106.106,0,0,1-.085-.04c-.071-.085-.137-.161-.2-.243a.11.11,0,0,1,.016-.161.111.111,0,0,1,.161.016l.2.242a.11.11,0,0,1-.014.161.107.107,0,0,1-.071.032Zm3.222-.034a.113.113,0,0,1-.061-.206l.263-.169a.111.111,0,0,1,.121.185l-.261.171a.11.11,0,0,1-.048.026Zm.524-.343a.111.111,0,0,1-.061-.2l.261-.172a.11.11,0,0,1,.161.032.108.108,0,0,1-.031.161l-.261.174a.122.122,0,0,1-.056.016Zm-4.147-.11a.108.108,0,0,1-.087-.042c-.121-.15-.2-.248-.2-.248a.111.111,0,1,1,.177-.135l.193.245a.111.111,0,0,1-.018.161.113.113,0,0,1-.056.026Zm4.672-.237a.108.108,0,0,1-.092-.048.111.111,0,0,1,.031-.161l.259-.176a.113.113,0,0,1,.161.031.111.111,0,0,1-.031.161l-.261.182a.124.124,0,0,1-.06.018Zm.52-.35a.111.111,0,0,1-.063-.2l.258-.176a.111.111,0,1,1,.126.184l-.259.176a.109.109,0,0,1-.053.026Zm.516-.353a.114.114,0,0,1-.092-.048.111.111,0,0,1,.029-.161l.255-.18a.113.113,0,0,1,.161.027.111.111,0,0,1-.026.161l-.258.18a.106.106,0,0,1-.061.027Zm.483-.392a.111.111,0,0,1-.087-.182c.052-.061.118-.143.195-.243a.113.113,0,0,1,.161-.018.111.111,0,0,1,.018.161l-.2.246a.116.116,0,0,1-.076.042Zm.39-.483a.113.113,0,0,1-.089-.18l.192-.247a.115.115,0,1,1,.182.14l-.193.248a.113.113,0,0,1-.079.039Zm.382-.5a.121.121,0,0,1-.068-.023.113.113,0,0,1-.021-.161l.19-.248a.111.111,0,0,1,.161-.023.113.113,0,0,1,.021.161l-.19.25a.108.108,0,0,1-.081.043Zm.38-.5a.114.114,0,0,1-.068-.023.11.11,0,0,1-.021-.161l.189-.25a.111.111,0,0,1,.177.135l-.188.25a.111.111,0,0,1-.076.048Zm.375-.5a.113.113,0,0,1-.066-.023.111.111,0,0,1-.023-.161l.187-.25a.111.111,0,0,1,.161-.023.11.11,0,0,1,.023.161l-.187.251a.116.116,0,0,1-.082.044Zm.375-.5a.108.108,0,0,1-.066-.021.111.111,0,0,1-.024-.161l.185-.251a.113.113,0,0,1,.161-.024.111.111,0,0,1,.024.161l-.187.251a.106.106,0,0,1-.081.045Zm.371-.5a.116.116,0,0,1-.066-.023.111.111,0,0,1-.024-.161c.063-.087.126-.171.184-.253a.113.113,0,0,1,.161-.026.111.111,0,0,1,.024.161c-.058.082-.121.161-.184.253a.113.113,0,0,1-.082.048Zm.367-.508a.115.115,0,0,1-.066-.021.113.113,0,0,1-.026-.161c.065-.09.126-.176.18-.255a.111.111,0,0,1,.161-.027.11.11,0,0,1,.027.161c-.055.081-.116.161-.18.258a.113.113,0,0,1-.084.053Zm.356-.516a.108.108,0,0,1-.061-.018.111.111,0,0,1-.031-.161,3,3,0,0,0,.161-.256.111.111,0,1,1,.2.1,2.975,2.975,0,0,1-.171.277.109.109,0,0,1-.082.055Zm.064-.535a.111.111,0,0,1-.087-.042c-.05-.064-.118-.143-.2-.235a.115.115,0,1,1,.172-.151c.082.1.151.179.2.245a.113.113,0,0,1-.079.184Zm-.409-.472a.109.109,0,0,1-.082-.037l-.213-.229a.111.111,0,0,1,.161-.151l.214.23a.111.111,0,0,1,0,.161.115.115,0,0,1-.068.026Zm-.429-.458a.113.113,0,0,1-.081-.034l-.216-.224a.114.114,0,0,1,.161-.161l.218.226a.111.111,0,0,1-.081.189Zm-.435-.448a.113.113,0,0,1-.081-.034l-.151-.161.079-.079-.044-.1c.071-.029.071-.029.276.18a.113.113,0,0,1-.079.19Z"
              transform="translate(-503.121 -118.719)"
              fill="#69402a"
            />
            <rect
              id="Rectangle_18234"
              data-name="Rectangle 18234"
              width="1.091"
              height="0.456"
              rx="0.228"
              transform="translate(41.79 23.529) rotate(-41.77)"
              fill="#69402a"
            />
            <path
              id="Path_35770"
              data-name="Path 35770"
              d="M539.34,131.183c.245.894.334,1.835.846,2.13a3.852,3.852,0,0,1,.161-.625c.282-.132.665-.119.727.121a1.773,1.773,0,0,0-.234.686,2.648,2.648,0,0,0,1.186-.1,3.419,3.419,0,0,0,.984-1.492,3.024,3.024,0,0,0-.775-1.521c-.292-.119-2.417-.567-2.417-.567Z"
              transform="translate(-502.837 -113.144)"
              fill="#f7b690"
            />
            <path
              id="Path_35771"
              data-name="Path 35771"
              d="M316.523,115.865c-.18-.392-.491-1.513-.909-1.772a3.574,3.574,0,0,0-2.1.031,3.42,3.42,0,0,0-.727,1.632c.044.264.7,1.305,1.015,1.374s2.478.161,2.478.161Z"
              transform="translate(-312.782 -99.833)"
              fill="#f7b690"
            />
            <path
              id="Path_35772"
              data-name="Path 35772"
              d="M450.307,80.279c2.277.59,6.714,1.751,8.185,2.658a43.655,43.655,0,0,1,6.034,5.388c.29.335-1.7,2.778-2.464,1.983a32.565,32.565,0,0,0-5.5-4.028c-2.256-.989-6.989-1.568-7.895-2.447C446.754,81.984,448.268,79.751,450.307,80.279Z"
              transform="translate(-426.036 -71.527)"
              fill="#74758a"
            />
            <path
              id="Path_35773"
              data-name="Path 35773"
              d="M397.913,28.727a1.1,1.1,0,0,1-1.45-.694c-.079-.433.727-1.663,2.694-1.663a2.761,2.761,0,0,1,2.533,1.22,10.455,10.455,0,0,1-.142,3.545C401.3,33.118,397.913,28.727,397.913,28.727Z"
              transform="translate(-382.976 -26.37)"
              fill="#2e4b5f"
            />
            <path
              id="Path_35774"
              data-name="Path 35774"
              d="M401.612,43.661c-.081-.029-.087-.569-.116-.983v-.031a1.567,1.567,0,0,1-.828.05,10.031,10.031,0,0,1-.5-2.24,9.357,9.357,0,0,1-.151-2.671c.027-.1,2.784-.6,2.95-.322a10.8,10.8,0,0,1,.517,2.193c.04.161.082.256.132.25.1-.013.137-.161.148-.377.026-.483-.068-1.26.287-1.279.213-.011.311.654.195,1.223-.042.214-.11.251-.174.23a7.733,7.733,0,0,0,.554,2.629C404.717,42.638,402.87,44.115,401.612,43.661Z"
              transform="translate(-385.918 -35.608)"
              fill="#f7b690"
            />
            <path
              id="Path_35775"
              data-name="Path 35775"
              d="M404.767,52.775a6.356,6.356,0,0,1-2.23,1.044,1.567,1.567,0,0,1-.828.05,10.035,10.035,0,0,1-.5-2.24,4.323,4.323,0,0,1,2.565.635c.24.116.9-.322.751-1.436.04.161.082.255.132.248.1-.013.137-.161.148-.377A9.234,9.234,0,0,1,404.767,52.775Z"
              transform="translate(-386.963 -46.78)"
              fill="#b3ae9e"
            />
            <path
              id="Path_35776"
              data-name="Path 35776"
              d="M444.9,215.645a.1.1,0,0,1-.06-.023c-.226-.184-.743-.728-1.241-1.253-.4-.419-.773-.815-.931-.954a.1.1,0,0,1,.124-.143c.161.145.545.545.944.967.472.5,1.007,1.06,1.223,1.237a.1.1,0,0,1,.014.134.1.1,0,0,1-.074.035Z"
              transform="translate(-421.716 -183.143)"
              fill="#878a94"
            />
            <path
              id="Path_35777"
              data-name="Path 35777"
              d="M447.088,90.079a.066.066,0,0,1-.064-.047,19.071,19.071,0,0,1-.193-3.831,12.506,12.506,0,0,0-.1-2.484.988.988,0,0,0-.506.076c-.224.068-.416.127-.529.044a.208.208,0,0,1-.077-.179,15.49,15.49,0,0,1,.632-4.342.068.068,0,1,1,.126.05,15.311,15.311,0,0,0-.622,4.292.089.089,0,0,0,.023.071c.058.042.251-.018.408-.064a.983.983,0,0,1,.6-.069c.158.068.187.773.179,2.607a19.536,19.536,0,0,0,.187,3.789.068.068,0,0,1-.045.085A.04.04,0,0,1,447.088,90.079Z"
              transform="translate(-424.214 -70.747)"
              fill="#ccc8bc"
            />
            <path
              id="Path_35778"
              data-name="Path 35778"
              d="M395.623,103.494a.068.068,0,0,1-.066-.053,26.97,26.97,0,0,0-1.51-3.569c-.715-1.514-.752-1.624-.678-1.69a.893.893,0,0,1,.411-.074,2.079,2.079,0,0,0,.292-.029c-.077-.044-.209-.1-.322-.161-.441-.2-.733-.35-.759-.514-.045-.284-.337-3.888.271-5.554a.069.069,0,0,1,.129.047,16.99,16.99,0,0,0-.266,5.486c.016.1.449.3.683.411.332.153.446.211.453.293a.093.093,0,0,1-.042.081,1.163,1.163,0,0,1-.429.071,2.322,2.322,0,0,0-.308.034c.042.161.371.864.688,1.537a26.247,26.247,0,0,1,1.519,3.6.069.069,0,0,1-.052.082Z"
              transform="translate(-379.975 -81.269)"
              fill="#ccc8bc"
            />
            <path
              id="Path_35779"
              data-name="Path 35779"
              d="M453.824,83.475a.045.045,0,0,1-.032-.016l-.116-.151a.043.043,0,0,1,.01-.058.04.04,0,0,1,.056.01l.114.15a.042.042,0,0,1-.032.066Zm-.229-.306a.042.042,0,0,1-.034-.018l-.106-.161a.042.042,0,0,1,.069-.045c.034.053.068.1.1.161a.044.044,0,0,1-.01.058A.045.045,0,0,1,453.6,83.169Zm-.2-.322a.04.04,0,0,1-.035-.019c-.034-.056-.064-.111-.1-.161a.041.041,0,1,1,.071-.04c.031.055.061.11.093.161a.04.04,0,0,1-.034.061Zm-.18-.322a.039.039,0,0,1-.035-.023c-.029-.058-.056-.114-.082-.172a.04.04,0,0,1,.019-.053.042.042,0,0,1,.055.019c.026.056.052.113.081.171a.042.042,0,0,1-.018.055A.04.04,0,0,1,453.21,82.524Zm-.161-.345a.042.042,0,0,1-.039-.026c-.024-.06-.047-.121-.068-.18a.042.042,0,0,1,.026-.052.04.04,0,0,1,.052.026c.021.058.044.118.066.176a.04.04,0,0,1-.023.053Zm-.126-.359a.04.04,0,0,1-.039-.029c-.019-.061-.035-.124-.05-.185a.041.041,0,1,1,.079-.019c.014.06.031.121.048.182a.039.039,0,0,1-.027.05Zm-.089-.369a.04.04,0,0,1-.04-.032c-.011-.064-.023-.127-.031-.19a.041.041,0,0,1,.082-.011,1.052,1.052,0,0,0,.027.185.04.04,0,0,1-.032.048Zm-.045-.377a.04.04,0,0,1-.04-.037v-.193a.04.04,0,0,1,.04-.04.042.042,0,0,1,.04.042v.179a.04.04,0,0,1-.04.05Zm0-.379a.04.04,0,0,1-.04-.043,1.222,1.222,0,0,1,.024-.192.042.042,0,0,1,.047-.034.04.04,0,0,1,.034.047c-.01.06-.018.122-.024.185a.04.04,0,0,1-.04.029Zm.064-.374h-.01a.039.039,0,0,1-.029-.05c.018-.063.039-.126.061-.184a.04.04,0,0,1,.053-.023.039.039,0,0,1,.023.052,1.524,1.524,0,0,0-.058.177.042.042,0,0,1-.034.019Zm.14-.351a.04.04,0,0,1-.035-.061,1.5,1.5,0,0,1,.108-.161.04.04,0,0,1,.056,0,.042.042,0,0,1,.008.058,1,1,0,0,0-.1.161.045.045,0,0,1-.031,0Zm.234-.3a.043.043,0,0,1-.031-.013.04.04,0,0,1,0-.058.98.98,0,0,1,.161-.118.042.042,0,0,1,.056.015.04.04,0,0,1-.014.055.941.941,0,0,0-.145.108.037.037,0,0,1-.021,0Zm1.234-.05a.045.045,0,0,1-.021,0,1.764,1.764,0,0,0-.161-.084.04.04,0,1,1,.031-.074,1.46,1.46,0,0,1,.174.087.04.04,0,0,1,.016.055.039.039,0,0,1-.032.008Zm-.91-.142a.04.04,0,0,1-.039-.027.042.042,0,0,1,.026-.052.985.985,0,0,1,.193-.042.042.042,0,0,1,.01.082.721.721,0,0,0-.177.037Zm.561,0h-.01a1.222,1.222,0,0,0-.18-.034.04.04,0,0,1-.037-.043.042.042,0,0,1,.045-.037,1.194,1.194,0,0,1,.193.035.042.042,0,0,1,.029.05.044.044,0,0,1-.034.011Z"
              transform="translate(-430.198 -70.822)"
              fill="#ccc8bc"
            />
            <path
              id="Path_35780"
              data-name="Path 35780"
              d="M320.7,116.606a.069.069,0,0,1-.055-.029,1.332,1.332,0,0,1-.143-.759,1.39,1.39,0,0,0-.008-.216,1.086,1.086,0,0,0-.171.1,1.123,1.123,0,0,1-.62.248.545.545,0,0,1-.516-.4.161.161,0,0,1,.121-.192,3.855,3.855,0,0,0,1.052-.644.068.068,0,0,1,.084.106,4.028,4.028,0,0,1-1.1.669c-.018,0-.031.011-.027.045a.424.424,0,0,0,.388.28,1.05,1.05,0,0,0,.54-.226c.151-.1.272-.179.345-.087.045.055.045.161.044.322a1.317,1.317,0,0,0,.119.68.068.068,0,0,1-.018.093A.066.066,0,0,1,320.7,116.606Z"
              transform="translate(-318.154 -100.468)"
              fill="#eb8e75"
            />
            <path
              id="Path_35781"
              data-name="Path 35781"
              d="M315.853,123.046a.524.524,0,0,1-.2-.031.068.068,0,1,1,.052-.124,1.164,1.164,0,0,0,.806-.172c.045-.034.1-.085.093-.139a.106.106,0,0,0-.047-.06,2.506,2.506,0,0,0-1.276-.129.068.068,0,1,1-.032-.131,2.582,2.582,0,0,1,1.387.15.211.211,0,0,1,.1.161.292.292,0,0,1-.147.261A1.434,1.434,0,0,1,315.853,123.046Z"
              transform="translate(-314.804 -106.784)"
              fill="#eb8e75"
            />
            <path
              id="Path_35782"
              data-name="Path 35782"
              d="M315.726,119.143H315.7a1.488,1.488,0,0,0-.416-.037.068.068,0,1,1,0-.135,1.638,1.638,0,0,1,.459.044.066.066,0,0,1,.042.085A.064.064,0,0,1,315.726,119.143Z"
              transform="translate(-314.827 -104.05)"
              fill="#eb8e75"
            />
            <path
              id="Path_35783"
              data-name="Path 35783"
              d="M317.788,115.8a.066.066,0,0,1-.055-.029,1.729,1.729,0,0,0-.769-.042.068.068,0,1,1-.024-.134,1.428,1.428,0,0,1,.9.1.068.068,0,0,1-.014.1A.074.074,0,0,1,317.788,115.8Z"
              transform="translate(-316.224 -101.201)"
              fill="#eb8e75"
            />
            <path
              id="Path_35784"
              data-name="Path 35784"
              d="M559.374,141.922a.068.068,0,0,1-.068-.069.969.969,0,0,0-.074-.388.272.272,0,0,0-.027-.076.071.071,0,0,1,.043-.087.068.068,0,0,1,.085.042l.026.076a1.062,1.062,0,0,1,.082.435A.068.068,0,0,1,559.374,141.922Z"
              transform="translate(-519.499 -122.781)"
              fill="#eb8e75"
            />
            <path
              id="Path_35785"
              data-name="Path 35785"
              d="M556.946,144.589a.069.069,0,0,1-.068-.072,1.094,1.094,0,0,0-.171-.607.068.068,0,1,1,.119-.064,1.227,1.227,0,0,1,.187.68A.068.068,0,0,1,556.946,144.589Z"
              transform="translate(-517.4 -124.888)"
              fill="#eb8e75"
            />
            <path
              id="Path_35786"
              data-name="Path 35786"
              d="M554.235,147.862h-.024a.068.068,0,0,1-.04-.087.925.925,0,0,0-.042-.549.068.068,0,0,1,.127-.047,1.055,1.055,0,0,1,.042.644A.066.066,0,0,1,554.235,147.862Z"
              transform="translate(-515.24 -127.677)"
              fill="#eb8e75"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
